import { Link } from 'react-router-dom';
import './StaticPages.css';

export default function Ambulance() {
  return (
    <div className="static-page">
      <div className="container">
        <div className="coming-soon-content">
          <div className="coming-soon-icon">🚑</div>
          <h1>Ambulance Service</h1>
          <p>We're preparing to launch our fastest and most reliable ambulance service!</p>
          <div className="coming-soon-details">
            <p>Coming features:</p>
            <ul>
              <li>Emergency ambulance dispatch in minutes</li>
              <li>Real-time GPS tracking</li>
              <li>Trained emergency medical staff</li>
              <li>Available 24/7 across Kashmir</li>
              <li>Request through app in one click</li>
            </ul>
          </div>
          <Link to="/nurses" className="btn btn-teal">Explore Other Services</Link>
        </div>
      </div>
    </div>
  );
}
